module.exports = __webpack_public_path__ + "img/magento-custom-development@2x.afb16bb8.webp";